import { Box, useColorModeValue } from '@chakra-ui/react';

const SidebarBox = ({ children, boxProps }) => {
  const variantChange = '0.2s linear';
  const sidebarMargins = '0px';
  const sidebarRadius = '20px';
  const sidebarBg = useColorModeValue('white', 'navy.800');

  return (
    <Box display={{ sm: 'none', xl: 'block' }} position="fixed" {...boxProps}>
      <Box
        bg={sidebarBg}
        transition={variantChange}
        w="260px"
        maxW="260px"
        ms={{
          sm: '16px',
        }}
        my={{
          sm: '16px',
        }}
        h="calc(100vh - 32px)"
        px="20px"
        py="12px"
        m={sidebarMargins}
        filter="drop-shadow(0px 5px 14px rgba(0, 0, 0, 0.05))"
        borderRadius={sidebarRadius}
      >
        {children}
      </Box>
    </Box>
  );
};

export default SidebarBox;
